import { useSelf } from "@ui/services/useUser";
import { ReactNode, createContext, useContext, useMemo } from "react";
import useConfiguration, {
  ITimeConfiguration,
} from "src/services/useConfiguration";

interface IContextProps {
  time?: ITimeConfiguration;
  isMachdatum?: boolean;
}

export const ConfigurationContext = createContext<IContextProps>({});
export const useConfigurationContext = () => useContext(ConfigurationContext);

function ConfigurationProvider(props: { children: ReactNode }) {
  const { configuration } = useConfiguration<ITimeConfiguration>("time");
  const { data: me } = useSelf<any>();
  const groups = me?.groups ?? [];
  const isMachdatum = groups.some((group: any) => group.name === "machdatum");

  const value = useMemo(
    () => ({
      time: configuration.data,
      isMachdatum,
    }),
    [configuration.data, isMachdatum],
  );

  return (
    <ConfigurationContext.Provider value={value}>
      {props.children}
    </ConfigurationContext.Provider>
  );
}

export default ConfigurationProvider;
